
const data = {
    title: 'هشدار',
    description: 'تمامی سرویس‌های ما، از جمله تایید هویت و ارائه تاییدیه‌های مرتبط با اطلاعات مختلف، با هدف افزایش امنیت، اعتماد و شفافیت در معاملات طراحی شده‌اند. تاییدیه‌های صادرشده صرفاً بر اساس اطلاعات و مدارک ارائه‌شده توسط کاربران انجام می‌شوند و استعلام می‌گردند. تنها محتوای موجود در این صفحه مورد تایید است و سایر اطلاعات خارج از محدوده مسئولیت ما می‌باشد. همچنین، عملکرد آگهی‌گذار به هیچ عنوان تأیید نمی‌شود.',
    texts: [
        'تایید هویت یا استعلام اطلاعات به معنای تضمین رفتار آگهی‌دهنده، کیفیت کالا/خدمت یا صحت سایر جزئیات ارائه‌شده توسط او نیست.',
        'در صورت وقوع تخلف، کلاهبرداری یا فعالیتی برخلاف قوانین دیوار، اطلاعات هویتی یا استعلام‌های مربوطه طبق قوانین دیوار و مراجع قانونی به شاکی ارائه می‌شود.',
        'این سرویس‌ها تنها برای تسهیل معاملات و ایجاد شفافیت طراحی شده‌اند و هیچ مسئولیتی در قبال اقدامات یا تعهدات کاربران بر عهده ما نخواهد بود.',
        'پیشنهاد می‌کنیم پیش از هرگونه معامله، جوانب احتیاط لازم را رعایت کرده و اطلاعات کامل و دقیق را از آگهی‌دهنده دریافت کنید.'

    ]
}


const WidgetRules=()=>{


    return <div className="p-5 bg-white w-full  lg:col-span-4  rounded-lg">
        <div className="flex justify-start items-center">

            <div className="flex flex-col">
                <div className="w-full flex justify-start items-center">

                    <div className="flex flex-col">
                        <p className=" font-semibold">لطفا نکات زیر را با دقت مطالعه نمایید.</p>
                    </div>

                </div>

                <span className="text-sm mt-3 border-t pt-3 ">{data.description}</span>

            </div>
        </div>
        <div className="  "/>
        <ul className="list-disc list-inside">
            {data.texts.map(text => <li className="mt-3 border-t pt-3 text-sm">{text}</li>)}
        </ul>

    </div>
}
export default WidgetRules;